import { FieldProps } from 'formik';
import { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DeclarationField from 'views/declarations/common/DeclarationField';
import { getFormikProps } from 'views/declarations/utils/form-utils';
import FormInput from '../../../../../components/ui/composed/declarations/formInput/DeclarationInput';
import { ValidationSchema, validators } from '../validations/validations';

type Fields = 'id';

export const commodityCusCodeBlockValidation: {
    childValidators: {
        'commodity.classification.cv': ValidationSchema<Fields>;
    };
} = {
    childValidators: {
        'commodity.classification.cv': {
            childValidators: {
                id: [validators.exact(8)],
            },
        },
    },
};

export const commodityCusCodeFields = commodityCusCodeBlockValidation.childValidators['commodity.classification.cv'];

interface Props extends BlockProps<Fields> {}

const CommodityCusCodeBlock = ({ path = 'commodity.classification.cv', fieldOptions }: Props): ReactElement => {
    const { t } = useTranslation('form');

    const ucc = useMemo(() => '6/13', []);
    return (
        <DeclarationField pathPrefix={path} name="id">
            {({ form, field }: FieldProps<any>) => (
                <FormInput
                    refNumber={ucc}
                    label={t('commodityCusCodeIdentifier')}
                    {...getFormikProps(field.name, form)}
                    condensed
                />
            )}
        </DeclarationField>
    );
};

export default CommodityCusCodeBlock;
